<template>
    <base-modal hide-footer hide-header @close="close">
        <div class="col-12" @click.stop="">
            <h3 class="editor-header">{{ $t('orders.file_download_title') }}</h3>
            <div class="row px-2 mb-3">
                <div
                    v-for="option in downloadModeOptions"
                    :key="option.value"
                    class="form-check"
                >
                    <input
                        class="form-check-input"
                        type="radio"
                        :id="'download-' + option.value"
                        :value="option.value"
                        v-model="downloadMethod"
                        name="method-radio-options"
                    />
                    <label
                        class="form-check-label"
                        :for="'download-' + option.value"
                    >
                        {{ option.text }}
                    </label>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-sm-12">
                    {{ $t('orders.geojson_download_text') }}
                </div>
            </div>

            <div class="row px-2 mb-3">
                <div
                    v-for="option in coordinateModeOptions"
                    :key="option.value"
                    class="form-check"
                >
                    <input
                        class="form-check-input"
                        type="radio"
                        :id="'coord-' + option.value"
                        :value="option.value"
                        v-model="coordSystem"
                        name="coord-radio-options"
                    />
                    <label
                        class="form-check-label"
                        :for="'coord-' + option.value"
                    >
                        {{ option.text }}
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="col-12 text-end">
                    <button
                        type="button"
                        class="btn btn-secondary form-button me-2"
                        @click.stop="close"
                    >
                        {{ $t('common.close') }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-success form-button"
                        @click.stop="downloadData"
                    >
                        {{ $t('common.download') }}
                    </button>
                </div>
            </div>
        </div>
    </base-modal>
</template>

<script>

import {coordinateSystems, downloadOptions} from "@/components/mixins/CoordinateConversionMixin";
import BaseModal from "@/components/BaseModal";

export default {
    name: "GeometryLayerDownload",
    components: {BaseModal},
    props: {
        coordinateSystems: {
            type: Object,
            default: null
        },
        geometryLayer: {
            type: Object,
            default: null
        },
        downloadModal: {
            type: Boolean,
            default: false
        },
        excludedFields: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data() {
        return {
            coordSystem: coordinateSystems.WGS84,
            downloadMethod: downloadOptions.GEOJSON,
        }
    },
    computed: {
        downloadModeOptions() {
            return [
                {text: this.$t('orders.download_geojson'), value: downloadOptions.GEOJSON},
                {text: this.$t('trip.download_shape'), value: downloadOptions.SHAPE},
            ]
        },
        coordinateModeOptions() {
            return [
                {text: this.$t('orders.download_wg84_title'), value: coordinateSystems.WGS84},
                {text: this.$t('orders.download_tm35_title'), value: coordinateSystems.TM35_FIN},
            ]
        }
    },

    methods: {
        downloadData() {
            let modifiedGeometryLayer = this.modifyGeometry(this.geometryLayer)
            // Emit the modified geometry layer and the coordinate system
            this.$emit(this.downloadMethod, modifiedGeometryLayer, this.coordSystem);
        },

        modifyGeometry(geometryLayer) {
            // Deep clone the geometryLayer to avoid mutating the original
            let modifiedGeometryLayer = JSON.parse(JSON.stringify(geometryLayer));

            if (modifiedGeometryLayer && modifiedGeometryLayer.geometry && modifiedGeometryLayer.geometry.features && modifiedGeometryLayer.geometry.features.length > 0) {
                modifiedGeometryLayer.geometry.features.forEach(feature => {
                    if (feature.properties) {
                        // Iterate over the excludedFields array and delete the matching properties
                        this.excludedFields.forEach(field => {
                            delete feature.properties[field];
                        });
                    }
                });
            }
            return modifiedGeometryLayer
        },

        close() {
            this.$emit("close")
        },
    }
}
</script>
